import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const Faq = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  // Accordion
  const [openAccordionIndex, setOpenAccordionIndex] = useState(0)

  const handleToggle = index => {
    setOpenAccordionIndex(openAccordionIndex === index ? -1 : index)
  }

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`faq common-accordion pt-70 pb-50 lgscreen:pt-30 lgscreen:pb-30 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid"
          >
            {module?.faqs && (
              <div className="accordion-main max-w-[930px] mx-auto pt-30 grid gap-y-[75px] lgscreen:gap-y-[30px]">
                <div className="accordion-grid">
                  {module?.heading && (
                    <motion.h5
                      variants={animFade}
                      className="uppercase font-500 tracking-0.04em mb-25"
                    >
                      {module.heading}
                    </motion.h5>
                  )}
                  {module?.faqs.map((item, i) => (
                    <div key={i} className={`accordion accordion-${i + 1}`}>
                      <div
                        className={`accordion__item ${
                          openAccordionIndex === i ? "open" : "close"
                        }`}
                      >
                        <motion.button
                          variants={animFade}
                          className="accordionItemButton w-full text-left relative outline-none py-20 flex items-center justify-between gap-x-10 px-30 mdscreen:!p-15"
                          onClick={() => handleToggle(i)}
                          onKeyDown={() => {
                            handleToggle(i)
                          }}
                          aria-hidden="true"
                        >
                          {item?.heading && (
                            <span className="text-15 tracking-0.04em uppercase font-400 block text-white-100">
                              {item.heading}
                            </span>
                          )}
                        </motion.button>
                        <div className="accordian-content-wrapper pt-20 mdscreen:pt-15">
                          <motion.div
                            variants={animFade}
                            className="accordian-content overflow-hidden"
                          >
                            <div className="max-w-[722px] pl-40 lgscreen:pl-20">
                              {item?.description && (
                                <div className="content global-list">
                                  {parse(item.description)}
                                </div>
                              )}
                            </div>
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default Faq
export const PageFaqFragment = graphql`
  fragment PageFaqFragment on WpPage_Pagecontent_PageContent_Faq {
    extraClass
    extraId
    hideSection
    faqs {
      description
      heading
    }
    heading
  }
`
